//import axios from 'axios';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  visitors: [
    {
        'id': 100,
        'first_name' : 'kazi',
        'last_name' : 'ahsan',
        'email' : 'ahsan@gmail.com',
        'chathistory' : [
            
        ]
    },
    {
        'id': 200,
        'first_name' : 'tom',
        'last_name' : 'cruise',
        'email' : 'tom@gmail.com',
        'chathistory' : [
            
        ]
    },
    
  ],

  visitor: {
        id: '',
        first_name: 'tom',
        last_name : '',
        email: '',
        chathistory: []
    }
};

export const VisitorSlice = createSlice({
  name: 'visitor',
  initialState,
  reducers: {
    addVisitors: (state, action) => {
        console.log('this will update visitors')
    },
    selectVisitor: (state, action) => {
        let payload = action.payload
        //console.log(`visitor123`)
        console.log(payload.id)
        
        let temp_visitors = state.visitors
        let temp_visitor = temp_visitors.find(item => item.id === payload.id);
        console.log(temp_visitor.first_name)

        return {
          ...state,
          visitor :
             {
              first_name: temp_visitor.first_name,
              last_name : temp_visitor.last_name,
              email: temp_visitor.email,
              chathistory: [...temp_visitor.chathistory]
             }
          
        }
    },

    updateVisitor: (state, action) => {
       let payload = action.payload
        console.log(payload.id)

        let temp_visitors = state.visitors
        let index = temp_visitors.findIndex(item => item.id === payload.id);
        let temp_visitor = temp_visitors[index]

        const visitors = state.visitors

        let temp_state =  {
           ...state,
           visitors :  visitors.map((visitor) => {
                         if(visitor.id === payload.id) {
		                    return {
		                       ...visitor,
		                       chathistory:[...visitor.chathistory, {
		                           'sender': 'staff',
		                           'message': payload.message,
		                           'created_date' : '####'
		                        }]
		                    }
		                  } 

                          return visitor
		    })

        }

        return {
          ...temp_state,
          visitor :
             {
              first_name: temp_visitor.first_name,
              last_name : temp_visitor.last_name,
              email: temp_visitor.email,
              chathistory: [...temp_state.visitors[index]['chathistory']]
             }
          
        }
    }
  },
});


export const { selectVisitor , updateVisitor} = VisitorSlice.actions;
export default VisitorSlice.reducer;